var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"platform-button",class:_vm.active ? 'active' : '',attrs:{"disabled":_vm.disabled,"large":"","color":""},on:{"click":_vm.choosePlatform}},[_c('Icon',{attrs:{"name":_vm.icon,"color":_vm.active ? 'white' : 'black'}}),_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm.title)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }